import { render, staticRenderFns } from "./matchmaker.vue?vue&type=template&id=21691367"
import script from "./matchmaker.vue?vue&type=script&lang=js"
export * from "./matchmaker.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\lptni\\开发\\dev\\project\\unbox-server\\vue-admin\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('21691367')) {
      api.createRecord('21691367', component.options)
    } else {
      api.reload('21691367', component.options)
    }
    module.hot.accept("./matchmaker.vue?vue&type=template&id=21691367", function () {
      api.rerender('21691367', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/system/components/updatePassWord/matchmaker.vue"
export default component.exports